export const getters = {
  allMeetings: state => state.meetings,
  currentMeeting: state => state.meeting,
  userAgenda: state => state.agenda,
  uiFlags: state => state.uiFlags,
};
